module.exports = __webpack_public_path__ + "img/624.b27a604e.jpg";